export default "__VITE_ASSET__BgLkLa0p__"